import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  const pageBackground = theme.palette.grey[400];

  return {
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: pageBackground,
      direction: "rtl",
      overflow: "hidden",
    },

    scrollContent: {
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
      padding: 0,
      boxSizing: "border-box",
      background: pageBackground,
      display: "flex",
      flexDirection: "column",
    },

    pageContent: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      gap: 16,
      opacity: 1,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
      overflow: "hidden",
    },

    pageHeader: {
      flexShrink: 0,
      display: "flex",
      flexDirection: "column",
      gap: 16,
    },

    tableWrapper: {
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
    },
  };
});
